import { jsx } from "panel";
import { PropertiesMenuEl } from "common/query-builder/query-block/properties-menu";
import { EventsMenuEl } from "common/query-builder/query-block/events-menu";
import { renameEvent } from "common/report/util/events";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
export function template() {
  const { searchFilter } = this.state;
  const selectedEvent = this.getSelectedEvent();
  let menuEl;
  if (selectedEvent == null ? void 0 : selectedEvent.value) {
    menuEl = /* @__PURE__ */ jsx(PropertiesMenuEl, {
      attrs: {
        ...this.attrs(),
        "search-filter": searchFilter,
        "event-names": [selectedEvent.value],
        selected: this.getSelectedProperty(),
        "all-data-groups": false,
        "project-has-people": false,
        "project-has-cohorts": false
      },
      key: "properties-menu",
      props: {
        context: `breakdown`
      },
      on: {
        select: this.helpers.handleSelectProperty,
        tooltipContextEditDescription: this.helpers.propagateEvent,
        openedModal: this.helpers.propagateEvent,
        closedModal: this.helpers.propagateEvent
      },
      hook: { insert: (vnode) => this.childMenu = vnode.elm }
    }, /* @__PURE__ */ jsx("div", {
      attrs: { slot: `menu-header` }
    }, /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".truncated",
      attrs: {
        icon: `arrow-left`,
        size: ButtonSize.Small,
        theme: ButtonTheme.Tertiary
      },
      on: {
        click: () => this.update({ staged: null })
      }
    }, "Properties on ", renameEvent(selectedEvent.value))));
  } else {
    menuEl = /* @__PURE__ */ jsx(EventsMenuEl, {
      attrs: {
        open: this.attr(`open`),
        "search-filter": searchFilter,
        "data-group-id": this.attr(`data-group-id`),
        "project-id": this.attr(`project-id`),
        "workspace-id": this.attr(`workspace-id`),
        selected: this.getSelectedEvent()
      },
      props: {
        context: `breakdown`
      },
      key: "events-menu",
      on: {
        select: (ev) => this.handleSelectEvent(ev.detail.item),
        tooltipContextAction: this.helpers.propagateEvent,
        tooltipContextEditDescription: this.helpers.propagateEvent
      },
      hook: { insert: (vnode) => this.childMenu = vnode.elm }
    });
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-breakdown-menu"
  }, menuEl);
}
